import * as React from 'react';
import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import Link from 'antd/lib/typography/Link';
import { TicketEpic } from '../../types';
import { antGrey } from '../styles/globalStyles';

interface EpicTagProps {
    epic: TicketEpic;
    size: 'small' | 'large';
}

// Chip for a ticket's epic, shown ahead of feature affiliation chips on cards and in the drawer
const EpicTag: React.FC<EpicTagProps> = ({ epic, size }) => {
    const sizeStyle: React.CSSProperties =
        size === 'large' ?
            { fontSize: '14px', lineHeight: '22px', height: '30px', display: 'flex', alignItems: 'center' }
        :   { fontSize: '11px', lineHeight: '15px', height: '18px' };

    return (
        <Tooltip title={epic.noun}>
            <Tag color={antGrey.grey5} style={{ color: antGrey.grey9, ...sizeStyle }}>
                <Link
                    href={epic.url}
                    target="_blank"
                    style={{ color: 'inherit', fontSize: 'inherit' }}
                    onClick={(e) => e.stopPropagation()} //stop drawer from opening
                >
                    {epic.title}
                </Link>
            </Tag>
        </Tooltip>
    );
};

export default EpicTag;
